import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';

interface RouteHistoryData {
  prevPathname?: string;
}

export const RouteHistoryContext = React.createContext<RouteHistoryData>({});

export const useRouteHistory = (): RouteHistoryData => useContext(RouteHistoryContext);

export const RouteHistoryProvider = ({
  children
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  const location = useLocation();
  const [currentRoute, setCurrentRoute] = useState(location.pathname);
  const [prevPathname, setPrevPathname] = useState<string>();

  useEffect(() => {
    if (currentRoute !== location.pathname) {
      setPrevPathname(currentRoute);
    }

    setCurrentRoute(location.pathname);
  }, [currentRoute, prevPathname, location.pathname]);

  const value = useMemo(
    () => ({
      prevPathname
    }),
    [prevPathname]
  );

  return <RouteHistoryContext.Provider value={value}>{children}</RouteHistoryContext.Provider>;
};
